import React from "react";
import cookie from "react-cookies";
import moment from "moment";
import InputMask from "react-input-mask";
import { Modal } from "react-bootstrap";

import { updateInfo } from "../../model/profile";

import { commonErr } from "../common/errors";
import { LoadingInline } from "../common/loading";

import { CustomInputSimple } from "../components/input";

export default class ChangeInfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			ip_displayname: props.profile.info.name,
			ip_gender: props.profile.info.gender,
			ip_dob: props.profile.info.dob > 0 ? moment(props.profile.info.dob).format("DD-MM-YYYY") : "01-01-1950",
			//
			err: commonErr.INNIT,
			errMsg: "",
		};
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	onSubmitBtnClick = () => {
		if (!moment(`${this.state.ip_dob}`, "DD-MM-YYYY").isValid()) {
			this.setState({ errMsg: "Ngày sinh không hợp lệ." });
		} else {
			const displayName = this.state.ip_displayname;
			const dateOfBirth = moment(`${this.state.ip_dob}`, "DD-MM-YYYY").valueOf();
			const gender = this.state.ip_gender;

			if (displayName !== "") {
				this.setState({
					err: commonErr.LOADING,
				});
				updateInfo(displayName, gender, dateOfBirth).then((resp) => {
					this.setState({
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
					if (resp.data.error === commonErr.SUCCESS) {
						this.props.getProfile();
						this.closeForm();

						//GA
						const utmSrc = cookie.load("_utm_src") || "web_directly";
						const utmExt = cookie.load("_utm_ext") || "no_label";
						// window.ga('send', 'event', utmSrc, "CHANGE_INFO_SUCCESS", utmExt);
						window.fbq("track", "CHANGE_INFO_SUCCESS");
						window.gtag("event", "CHANGE_INFO_SUCCESS", {
							event_category: utmSrc,
							event_label: utmExt,
							campaign: { source: utmSrc },
						});
					}
				});
			}
		}
	};

	onBackBtnClick = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	closeForm = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});

		this.props.hideModal();
	};

	render() {
		var content;
		if (this.state.errMsg && this.state.errMsg !== "") {
			content = (
				<div className="modal-confirm-body">
					<div className="textAlign-center">
						<i className="ic ic-error"></i> Cập nhật thất bại. {this.state.errMsg}
					</div>

					<button className="btn btn-primary btn--m" type="button" name="backBtn" onClick={this.onBackBtnClick}>
						Thử lại
					</button>
				</div>
			);
		} else {
			content = (
				<div className="modal-confirm-body">
					<CustomInputSimple
						label={"Tên tài khoản"}
						value={this.state.ip_displayname}
						name="ip_displayname"
						onChange={this.handleInputChange}
					/>
					<div className="custom-input">
						<div className="wrap-info">
							<div className="title-status">
								<p>Ngày sinh</p>
							</div>
						</div>
						<div className="wrap-input">
							<div className="wrap-text">
								<InputMask
									name="ip_dob"
									mask="99-99-9999"
									defaultValue={`${this.state.ip_dob}`}
									onChange={this.handleInputChange}
								/>
							</div>
						</div>
					</div>
					<div className="custom-input">
						<div className="wrap-info">
							<div className="title-status">
								<p>Giới tính</p>
							</div>
						</div>
						<div className="custom-select">
							<select name="ip_gender" defaultValue={this.state.ip_gender} onChange={this.handleInputChange}>
								<option value="1">Nam</option>
								<option value="2">Nữ</option>
							</select>
						</div>
					</div>
					<a className="btn btn-primary btn--m" type="button" onClick={this.onSubmitBtnClick}>
						Cập nhật {this.state.err === commonErr.LOADING && <LoadingInline />}
					</a>
				</div>
			);
		}

		return (
			<Modal show={this.props.show} onHide={this.props.hideModal} dialogClassName="modal-s modal-dialog modal-confirm">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Cập nhật thông tin</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}
